import { useNavigate } from "react-router-dom"
import { useUI } from "providers/UIProvider"

import { getColumns } from "./columns"

import Table from "components/UI/organisms/Table"
import { getActions } from "./actions"
import { UI_INITIAL_STATE } from "providers/UIProvider/UIProviderConstants"
import { useLaundriesContext } from "providers/LaundriesProvider/LaundriesProvider"

import BdsLogo from "assets/img/bds-logo.png"
import { Text, Image, Flex } from "@chakra-ui/react"

const LoundriesTable = () => {
  const navigate = useNavigate()

  const { T, toggleModal } = useUI()
  const { laundries, handleLaundriesPageChange, deleteLaundry, query } = useLaundriesContext()

  const handleEditClick = (data: { id: number }) => {
    navigate(`/laundries/${data.id}`)
  }
  const handleDeleteClick = (data: { name: string, id: number }) => {
    toggleModal("confirmationModal", true, {
      title: `დარწმუნებული ხართ, რომ გსურთ სამრეცხაო, ${data.name} წაშლა`,
      handleDeny: () => toggleModal("confirmationModal", false, UI_INITIAL_STATE.modals.confirmationModal.data),
      handleSubmit: () => deleteLaundry(data.id)
    })
  }
  const navigeteToHistory = (laundryId: number) => {
    navigate(`/laundry/${laundryId}/change_history`)
  }

  const tableActions = getActions({ T, handleEditClick, handleDeleteClick })
  const columns = getColumns(T, navigeteToHistory)
  return (
    <>
      <Table
        actions={tableActions}
        data={laundries.data}
        columns={columns}
        extraHeaderCols={1}
        pagination={{
          total: laundries.itemCount,
          perPage: query.pageSize,
          onClick: handleLaundriesPageChange,
          currentPage: query.pageIndex
        }}
      />
      <Flex style={{ flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "5px", height: "2rem" }}>
        <Text style={{
          opacity: "50%",
          fontSize: "11px",
          whiteSpace: "nowrap",
        }}>
          {"Powered by"}
        </Text>
        <a target='_blank'
          rel='noopener noreferrer' href="https://bds.ge">
          <Image alt="BDS Logo" src={BdsLogo} height="14px" />
        </a>
      </Flex>
    </>
  )
}

export default LoundriesTable 
